import { LogScreen } from '@/core/interfaces/logScreen';

export interface LogScreenGroup {
    group: string;
    children: LogScreen[];
}

export const isLogScreenGroup = (item: LogScreen | LogScreenGroup): item is LogScreenGroup => {
    return (item as LogScreenGroup).group !== undefined && (item as LogScreenGroup).children !== undefined;
};
